import { IconButton, Tooltip } from "@material-ui/core"
import { useDispatch } from "react-redux"
import HotelIcon from '@material-ui/icons/Hotel'
import { openModalPlazaPaqueteTerrestre } from "../../../ducks/proveedorTerrestreDuck"

const BPlaza = (props) => {
    const { paquete } = props
    const dispatch = useDispatch()

    const handleClick = () => {
        dispatch(openModalPlazaPaqueteTerrestre({
          paquete
        }))
    }

    return (
        <Tooltip title="Plaza">
            <IconButton aria-label="Declinar solicitud" onClick={handleClick}>
                <HotelIcon color="primary" />
            </IconButton>
        </Tooltip>
    )
}

export default BPlaza